import { Dialog, DialogTitle, IconButton } from "@mui/material";

import Checkout from "./Checkout";
import './PlansCard.scss';
export default function PlansCard(props) {
const handleClose = () => {
    props.setPlansCard(false);
  };
return ( <Checkout/>);
}